class Cart100Popup {
  constructor() {
    this.popup = document.getElementById('cart-100-popup');
    this.teaser = document.getElementById('cart-100-teaser');
    this.hasShown = false;
    this.productsAdded = false;
    this.threshold = 10000; // 100 USD in cents
    this.storageKey = 'cart100PopupClosed';
    this.teaserStorageKey = 'cart100TeaserVisible';
    
    console.log('Cart $100 popup: Constructor', {
      hasPopup: !!this.popup,
      hasTeaser: !!this.teaser,
      popupId: this.popup ? this.popup.id : 'not found',
      teaserId: this.teaser ? this.teaser.id : 'not found'
    });
    
    this.init();
  }

  init() {
    if (!this.popup) return;
    
    // Check if popup is enabled (this would be set by the section settings)
    const popupEnabled = this.popup.dataset.enabled !== 'false';
    if (!popupEnabled) return;
    
    // Check if popup was previously closed - this affects whether popup can show automatically
    this.hasShown = this.getPopupClosedState();
    
    console.log('Cart $100 popup: Initialized', {
      hasShown: this.hasShown,
      hasTeaser: !!this.teaser,
      popupEnabled
    });
    
    this.bindEvents();
    this.checkCartTotalOnLoad();
    
    // Check if teaser should be shown on page load (independent of popup state)
    this.checkTeaserOnLoad();
  }

  // Get popup closed state from localStorage
  getPopupClosedState() {
    try {
      return localStorage.getItem(this.storageKey) === 'true';
    } catch (error) {
      console.error('Error reading popup state from localStorage:', error);
      return false;
    }
  }

  // Set popup closed state in localStorage
  setPopupClosedState(closed) {
    try {
      localStorage.setItem(this.storageKey, closed.toString());
    } catch (error) {
      console.error('Error saving popup state to localStorage:', error);
    }
  }

  // Get teaser visible state from localStorage
  getTeaserVisibleState() {
    try {
      return localStorage.getItem(this.teaserStorageKey) === 'true';
    } catch (error) {
      console.error('Error reading teaser state from localStorage:', error);
      return false;
    }
  }

  // Set teaser visible state in localStorage
  setTeaserVisibleState(visible) {
    try {
      localStorage.setItem(this.teaserStorageKey, visible.toString());
    } catch (error) {
      console.error('Error saving teaser state to localStorage:', error);
    }
  }

  // Check if teaser should be shown on page load
  checkTeaserOnLoad() {
    const popupClosed = this.getPopupClosedState();
    const teaserVisible = this.getTeaserVisibleState();
    
    console.log('Cart $100 popup: Checking teaser on load', {
      popupClosed,
      teaserVisible,
      hasTeaser: !!this.teaser
    });
    
    // Show teaser if popup was closed AND teaser state is visible AND cart is >= $100
    if (this.teaser && popupClosed && teaserVisible) {
      // Check cart total before showing teaser
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const total = cart.total_price / 100;
          if (total >= 100) {
            console.log('Cart $100 popup: Showing teaser on page load (cart >= $100)');
            setTimeout(() => {
              this.showTeaser();
            }, 1000);
          } else {
            console.log('Cart $100 popup: Not showing teaser on page load (cart < $100)');
            // Clear teaser state since cart is below threshold
            this.setTeaserVisibleState(false);
          }
        })
        .catch(error => {
          console.error('Error checking cart total for teaser:', error);
        });
    }
  }

  bindEvents() {
    // Close button
    const closeBtn = this.popup.querySelector('.cart-100-popup__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.close());
    }

    // Continue shopping button
    const continueBtn = this.popup.querySelector('.cart-100-popup__continue');
    if (continueBtn) {
      continueBtn.addEventListener('click', () => this.close());
    }

    // Overlay click to close
    const overlay = this.popup.querySelector('.cart-100-popup__overlay');
    if (overlay) {
      overlay.addEventListener('click', () => this.close());
    }

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });

    // Add to cart buttons in popup
    const addToCartBtns = this.popup.querySelectorAll('.add-to-cart-popup');
    addToCartBtns.forEach(btn => {
      btn.addEventListener('click', (e) => this.handleAddToCart(e));
    });

    // Teaser close button
    if (this.teaser) {
      const teaserCloseBtn = this.teaser.querySelector('.cart-100-teaser__close');
      if (teaserCloseBtn) {
        teaserCloseBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.hideTeaser();
        });
      }

      // Teaser click to reopen popup
      const teaserContent = this.teaser.querySelector('.cart-100-teaser__content');
      if (teaserContent) {
        teaserContent.addEventListener('click', () => {
          this.show(true); // Force show when triggered by teaser
          this.hideTeaser();
          this.setTeaserVisibleState(false); // Clear teaser state when popup is reopened
        });
      }
    }

    // Listen for cart updates
    document.addEventListener('cart:updated', () => {
      this.checkCartTotal();
    });

    // Listen for cart changes via fetch
    this.observeCartChanges();
  }

  observeCartChanges() {
    // Listen for cart section updates (used by existing cart.js)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.target.id === 'main-cart-footer') {
          // Cart footer was updated, check total immediately and after a short delay
          this.checkCartTotal();
          setTimeout(() => this.checkCartTotal(), 500);
        }
      });
    });

    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) {
      observer.observe(cartFooter, { childList: true, subtree: true });
    }

    // Also listen for cart icon bubble updates
    const cartIconBubble = document.querySelector('.cart-count-bubble');
    if (cartIconBubble) {
      observer.observe(cartIconBubble, { childList: true, subtree: true });
    }

    // Listen for cart total element changes
    const cartTotalObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Cart total text changed, check total immediately and after a short delay
          this.checkCartTotal();
          setTimeout(() => this.checkCartTotal(), 500);
        }
      });
    });

    // Observe cart total elements
    const cartTotalElements = document.querySelectorAll('[data-cart-total], .cart__total, .totals__subtotal-value');
    cartTotalElements.forEach(element => {
      cartTotalObserver.observe(element, { childList: true, subtree: true, characterData: true });
    });

    // Override fetch to detect cart changes
    const originalFetch = window.fetch;
    window.fetch = (...args) => {
      const [url, options] = args;
      
      // Check if this is a cart-related request
      if (url && typeof url === 'string' && 
          (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
        
        return originalFetch.apply(this, args).then(response => {
          // Clone the response so we can read it
          const clonedResponse = response.clone();
          
          // Check if it's a JSON response
          const contentType = clonedResponse.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            clonedResponse.json().then(data => {
              if (data && data.item_count !== undefined) {
                // Cart was updated, check total immediately and after a short delay
                this.checkCartTotal();
                setTimeout(() => this.checkCartTotal(), 500);
              }
            }).catch(() => {
              // If JSON parsing fails, still check cart total
              this.checkCartTotal();
              setTimeout(() => this.checkCartTotal(), 500);
            });
          }
          
          return response;
        });
      }
      
      return originalFetch.apply(this, args);
    };

    // Add periodic checking as fallback (every 2 seconds)
    // Always check cart total to monitor for threshold changes
    this.cartCheckInterval = setInterval(() => {
      this.checkCartTotal();
    }, 2000);
  }

  checkCartTotal() {
    // Always fetch cart total via AJAX for more reliable detection
    this.fetchCartTotal();
  }

  // Also check when page loads
  checkCartTotalOnLoad() {
    // Check immediately
    this.checkCartTotal();
    
    // Check again after a short delay for dynamic content
    setTimeout(() => {
      this.checkCartTotal();
    }, 500);
    
    // Check again after a longer delay for any delayed updates
    setTimeout(() => {
      this.checkCartTotal();
    }, 2000);
  }

  // Check if any popup products are already in the cart
  async checkPopupProductsInCart() {
    try {
      // Get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      if (!cart.items || cart.items.length === 0) {
        return false; // No items in cart, so no conflicts
      }
      
      // Get popup product IDs
      const popupProductIds = this.getPopupProductIds();
      
      if (popupProductIds.length === 0) {
        return false; // No popup products to check
      }
      
      // Check if any popup products are in cart
      const cartProductIds = cart.items.map(item => item.product_id.toString());
      
      for (const popupProductId of popupProductIds) {
        if (cartProductIds.includes(popupProductId)) {
          return true; // Found a popup product in cart
        }
      }
      
      return false; // No popup products in cart
    } catch (error) {
      console.error('Error checking popup products in cart:', error);
      return false; // On error, allow popup to show
    }
  }

  // Get product IDs from popup products
  getPopupProductIds() {
    const popupProducts = this.popup.querySelectorAll('.add-to-cart-popup');
    const productIds = [];
    
    popupProducts.forEach(product => {
      const productId = product.dataset.productId;
      if (productId) {
        productIds.push(productId);
      }
    });
    
    return productIds;
  }

  fetchCartTotal() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const total = cart.total_price / 100; // Convert from cents to dollars
        
        console.log('Cart $100 popup: Checking cart total', {
          total,
          hasShown: this.hasShown,
          threshold: 100
        });
        
        // Check if cart total dropped below threshold
        if (total < 100) {
          console.log('Cart $100 popup: Cart total dropped below $100');
          
          // Hide teaser if it's visible (check both DOM state and localStorage state)
          const teaserVisible = this.isTeaserVisible();
          const teaserStateVisible = this.getTeaserVisibleState();
          
          console.log('Cart $100 popup: Teaser state check', {
            teaserVisible,
            teaserStateVisible,
            hasTeaser: !!this.teaser
          });
          
          if (this.teaser && (teaserVisible || teaserStateVisible)) {
            console.log('Cart $100 popup: Hiding teaser due to cart below threshold');
            this.hideTeaser();
            this.setTeaserVisibleState(false);
          }
          
          // Reset popup state so it can show again when threshold is met
          this.setPopupClosedState(false);
          this.hasShown = false;
          return;
        }
        
        // Cart total is >= $100
        if (!this.hasShown) {
          console.log('Cart $100 popup: Cart total >= $100 and popup not shown yet');
          // Check if we should skip when products are in cart
          const skipIfProductsInCart = this.popup.dataset.skipIfProductsInCart === 'true';
          
          if (skipIfProductsInCart) {
            // Check if any popup products are already in cart
            this.checkPopupProductsInCart().then(productsInCart => {
              if (!productsInCart) {
                this.show();
              } else {
                console.log('Cart $100 popup: Products already in cart, skipping popup');
              }
            });
          } else {
            // Show popup regardless of products in cart
            this.show();
          }
        }
      })
      .catch(error => {
        console.error('Error fetching cart total:', error);
      });
  }

  parsePrice(priceText) {
    // Remove currency symbols and convert to number
    const cleaned = priceText.replace(/[^0-9.,]/g, '');
    const number = parseFloat(cleaned.replace(',', '.'));
    return isNaN(number) ? 0 : number;
  }

  show(force = false) {
    // Allow reopening if forced (e.g., from teaser click)
    if (!force && (this.hasShown || this.isOpen())) return;
    
    // If forced show (from teaser), reset the closed state
    if (force) {
      this.setPopupClosedState(false);
    }
    
    this.hasShown = true;
    this.popup.style.display = 'flex';
    
    // Trigger animation
    setTimeout(() => {
      this.popup.classList.add('active');
    }, 10);

    // Focus management
    this.popup.focus();
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
    
    // Dispatch custom event
    document.dispatchEvent(new CustomEvent('cart100popup:shown'));
  }

  close() {
    if (!this.isOpen()) return;
    
    this.popup.classList.remove('active');
    
    // Wait for animation to complete
    setTimeout(() => {
      this.popup.style.display = 'none';
      document.body.style.overflow = '';
      
      // Mark popup as closed in localStorage
      this.setPopupClosedState(true);
      
      console.log('Cart $100 popup: Closing popup', {
        productsAdded: this.productsAdded,
        hasTeaser: !!this.teaser
      });
      
      // Always show teaser when popup is closed, unless products were added
      if (!this.productsAdded) {
        if (this.teaser) {
          console.log('Cart $100 popup: Will show teaser in 1 second');
          setTimeout(() => {
            this.showTeaser();
          }, 1000); // Show teaser 1 second after popup closes
        } else {
          // If no teaser element exists, still mark teaser as visible
          console.log('Cart $100 popup: No teaser element, but marking teaser as visible');
          this.setTeaserVisibleState(true);
        }
      } else {
        // If products were added, ensure teaser is hidden
        console.log('Cart $100 popup: Products added, hiding teaser');
        this.setTeaserVisibleState(false);
      }
    }, 300);
    
    // Dispatch custom event
    document.dispatchEvent(new CustomEvent('cart100popup:closed'));
  }

  isOpen() {
    return this.popup.classList.contains('active');
  }

  isTeaserVisible() {
    return this.teaser && this.teaser.classList.contains('active');
  }

  showTeaser() {
    if (!this.teaser) {
      console.log('Cart $100 popup: Cannot show teaser - teaser element not found');
      return;
    }
    
    console.log('Cart $100 popup: Showing teaser');
    
    this.teaser.style.display = 'block';
    
    // Trigger animation
    setTimeout(() => {
      this.teaser.classList.add('active');
    }, 10);
    
    // Save teaser visible state
    this.setTeaserVisibleState(true);
  }

  hideTeaser() {
    if (!this.teaser) return;
    
    this.teaser.classList.remove('active');
    
    // Wait for animation to complete
    setTimeout(() => {
      this.teaser.style.display = 'none';
    }, 300);
    
    // Save teaser hidden state
    this.setTeaserVisibleState(false);
  }

  handleAddToCart(e) {
    e.preventDefault();
    
    const button = e.currentTarget;
    const productId = button.dataset.productId;
    const variantId = button.dataset.variantId;
    
    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    // Disable button and show loading state
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Adding...';

    // Add to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status) {
        // Error occurred
        console.error('Error adding to cart:', data.description);
        button.textContent = 'Error';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      } else {
        // Success
        button.textContent = 'Added!';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 1000);
        
        // Mark that products were added
        this.productsAdded = true;
        
        // Clear popup closed state since products were added
        this.setPopupClosedState(false);
        
        // Hide teaser and clear its state since products were added
        this.hideTeaser();
        this.setTeaserVisibleState(false);
        
        // Update cart count and total
        this.updateCartUI(data);
        
        // Close popup after successful add
        setTimeout(() => {
          this.close();
        }, 1500);
      }
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.textContent = 'Error';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    });
  }

  updateCartUI(cartData) {
    // Update cart count
    const cartCountElements = document.querySelectorAll('.cart-count-bubble, .cart-icon-bubble');
    cartCountElements.forEach(element => {
      if (cartData.item_count > 0) {
        element.textContent = cartData.item_count;
        element.style.display = 'block';
      } else {
        element.style.display = 'none';
      }
    });

    // Update cart total if available
    const cartTotalElements = document.querySelectorAll('.cart__total, .totals__subtotal-value');
    cartTotalElements.forEach(element => {
      if (cartData.total_price) {
        const formattedPrice = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(cartData.total_price / 100);
        element.textContent = formattedPrice;
      }
    });

    // Dispatch cart updated event
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
  }

  reset() {
    this.hasShown = false;
    this.productsAdded = false;
    this.setPopupClosedState(false);
    this.setTeaserVisibleState(false);
    
    // Hide teaser if it's currently visible
    if (this.teaser && this.isTeaserVisible()) {
      this.hideTeaser();
    }
    
    console.log('Cart $100 popup: Reset all states');
  }

  destroy() {
    // Clean up interval
    if (this.cartCheckInterval) {
      clearInterval(this.cartCheckInterval);
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.cart100Popup = new Cart100Popup();
});

// Export for potential use in other scripts
window.Cart100Popup = Cart100Popup;

// Add global method to manually check cart total (useful for testing)
window.checkCart100Popup = () => {
  if (window.cart100Popup) {
    window.cart100Popup.checkCartTotal();
  }
};

// Add global method to reset popup state (useful for testing)
window.resetCart100Popup = () => {
  if (window.cart100Popup) {
    window.cart100Popup.reset();
  }
};

// Add global method to clear all popup localStorage data (useful for testing)
window.clearCart100PopupData = () => {
  try {
    localStorage.removeItem('cart100PopupClosed');
    localStorage.removeItem('cart100TeaserVisible');
    console.log('Cart $100 popup: Cleared all localStorage data');
  } catch (error) {
    console.error('Error clearing localStorage data:', error);
  }
};

// Add global method to check current popup state (useful for testing)
window.checkCart100PopupState = () => {
  try {
    const popupClosed = localStorage.getItem('cart100PopupClosed');
    const teaserVisible = localStorage.getItem('cart100TeaserVisible');
    console.log('Cart $100 popup: Current state', {
      popupClosed,
      teaserVisible,
      hasShown: window.cart100Popup ? window.cart100Popup.hasShown : 'N/A'
    });
  } catch (error) {
    console.error('Error checking popup state:', error);
  }
};

// Add global method to manually show teaser (useful for testing)
window.showCart100Teaser = () => {
  if (window.cart100Popup) {
    window.cart100Popup.showTeaser();
  } else {
    console.log('Cart $100 popup: Instance not found');
  }
};

// Add global method to simulate popup close without adding products (useful for testing)
window.simulatePopupClose = () => {
  if (window.cart100Popup) {
    // Set popup as closed
    window.cart100Popup.setPopupClosedState(true);
    window.cart100Popup.hasShown = true;
    
    // Show teaser
    window.cart100Popup.showTeaser();
    
    console.log('Cart $100 popup: Simulated popup close and teaser show');
  } else {
    console.log('Cart $100 popup: Instance not found');
  }
};

// Add global method to fix current state and show teaser (useful for testing)
window.fixAndShowTeaser = () => {
  if (window.cart100Popup) {
    // Fix the teaser state since it's currently null
    window.cart100Popup.setTeaserVisibleState(true);
    
    // Show the teaser
    window.cart100Popup.showTeaser();
    
    console.log('Cart $100 popup: Fixed teaser state and showing teaser');
  } else {
    console.log('Cart $100 popup: Instance not found');
  }
};

// Add global method to test cart threshold behavior (useful for testing)
window.testCartThreshold = () => {
  if (window.cart100Popup) {
    console.log('Cart $100 popup: Testing cart threshold behavior');
    window.cart100Popup.checkCartTotal();
  } else {
    console.log('Cart $100 popup: Instance not found');
  }
};

// Add global method to simulate cart total change (useful for testing)
window.simulateCartChange = (total) => {
  if (window.cart100Popup) {
    console.log(`Cart $100 popup: Simulating cart total change to $${total}`);
    
    // Mock the cart response
    const mockCart = {
      total_price: total * 100, // Convert to cents
      item_count: 1
    };
    
    // Call the cart total processing logic directly
    const originalFetch = window.fetch;
    window.fetch = (url) => {
      if (url === '/cart.js') {
        return Promise.resolve({
          json: () => Promise.resolve(mockCart)
        });
      }
      return originalFetch(url);
    };
    
    // Trigger cart check
    window.cart100Popup.checkCartTotal();
    
    // Restore original fetch
    setTimeout(() => {
      window.fetch = originalFetch;
    }, 1000);
  } else {
    console.log('Cart $100 popup: Instance not found');
  }
}; 